module.exports = __webpack_public_path__ + "static/media/empty-heart.0984040e.svg";